import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { format, parseISO } from "date-fns";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Safely format a possibly-bad ISO date string. Bulk-imported CSVs sometimes
 * carry empty strings or malformed dates that would crash `format()` with
 * "Invalid time value" and take the whole list down with them.
 */
export function safeFormatDate(value: string | null | undefined, pattern: string, fallback = "—"): string {
  if (!value) return fallback;
  const parsed = parseISO(value);
  if (Number.isNaN(parsed.getTime())) return fallback;
  return format(parsed, pattern);
}
